import React, { useEffect } from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const VideoModal = ({ videoId, open, onClose }) => {
  // Cleanup: stop video when modal closes
  useEffect(() => {
    if (!open) {
      // Give time for dialog animation
      setTimeout(() => {
        // Video will be unmounted, stopping playback
      }, 300);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full p-0 overflow-hidden">
        <div className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-2 right-2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full"
            onClick={onClose}
            data-testid="video-modal-close-button"
          >
            <X className="w-5 h-5" />
          </Button>
          
          {videoId && (
            <div className="video-responsive">
              <iframe
                src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid={`episodes-open-modal-${videoId}`}
              />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
